export enum NotificationChannelModelType {
    Email = "email",
    SMS = "sms",
    Telegram = "telegram",
    Slack = "slack",
    Teams = "teams",
    WebPush = "web_push",
}

export class NotificationChannelWebPushKeysModel {
    auth: string;
    p256dh: string;
}

export class NotificationChannelWebPushSubscriptionModel {
    endpoint: string;
    expirationTime?: number;
    language?: string;
    keys: NotificationChannelWebPushKeysModel;
}

export class NotificationChannelConfigModel {
    emails?: string[];
    phoneNumbers?: string[];
    webhookUrl?: string;
    hasWebhookUrl?: boolean;
    chatIds?: string[];
    language?: string;
}

export class NotificationChannelModel {
    id: string;
    name: string;
    type: NotificationChannelModelType;
    enabled = true;
    config: NotificationChannelConfigModel;
}
